import { useFieldFormContext } from "@/features/question/components/organisms/FieldForm";
import { Input } from "@/components/ui/input";
import { useEffect, useState } from "react";


export function DurationDaysForm() {
    const { isFormDisabled, form } = useFieldFormContext();

    const field_min = form?.watch('field_min');
    const field_max = form?.watch('field_max');

    const [min, setMin] = useState<string>(field_min?.toString() || "0");
    const [max, setMax] = useState<string>(field_max?.toString() || "10");
    useEffect(() => {
        setMin("0");
        setMax("10");
    }, []);
    useEffect(() => {
        form?.setValue("field_min", min ? parseInt(min) : null)
        form?.setValue("field_max", max ? parseInt(max) : null)
    }, [form, min, max]);

    return (
        <div className="flex flex-col gap-2">
            <p className="text-sm font-medium">Minimum number</p>
            <Input
                value={min}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setMin(e.target.value)}
                disabled={isFormDisabled}
                type='number'
                autoComplete="off"
            />
            <p className="text-sm font-medium">Maximum number</p>
            <Input
                value={max}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setMax(e.target.value)}
                disabled={isFormDisabled}
                type='number'
                autoComplete="off"
            />
        </div>
    )
}